import React from 'react';

import './BdsDivider.scss';

interface DividerProps {
  size: 's' | 'm';
  color: 'subtle' | 'high' | 'light';
  orientation?: 'horizontal' | 'vertical';
}

const BdsDivider = ({ size, color, orientation = 'horizontal' }: DividerProps) => {
  return <div className={`bds-divider ${size} ${color} ${orientation}`} data-testid="bds-divider" />;
};

export default BdsDivider;
